import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import Summary from './components/Summary';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Resume from './components/Resume';
import Contact from './components/Contact';

const navigation = [
  { href: '#about', label: 'About' }, { href: '#experience', label: 'Experience' },
  { href: '#skills', label: 'Capabilities' }, { href: '#resume', label: 'Résumé' }, { href: '#contact', label: 'Contact' }
];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const sections = navigation.map(({ href }) => document.querySelector(href)).filter(Boolean);
    const links = Array.from(document.querySelectorAll('.site-nav a'));
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.find((entry) => entry.isIntersecting);
      if (visible) links.forEach((link) => link.classList.toggle('is-active', link.getAttribute('href') === `#${visible.target.id}`));
    }, { rootMargin: '-35% 0px -55% 0px' });
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);
  return <div className="site-shell">
    <header className="site-header"><a className="wordmark" href="#top" aria-label="Jacob Fishman, home">JF<span>.</span></a>
      <button className="menu-button" type="button" aria-expanded={menuOpen} aria-controls="site-navigation" onClick={() => setMenuOpen((open) => !open)}><span className="sr-only">Toggle navigation</span><span /><span /></button>
      <nav id="site-navigation" className={`site-nav ${menuOpen ? 'is-open' : ''}`} aria-label="Primary navigation">{navigation.map((item) => <a key={item.href} href={item.href} onClick={() => setMenuOpen(false)}>{item.label}</a>)}</nav>
    </header>
    <main id="top"><Header /><Summary /><Experience /><Skills /><Resume /><Contact /></main>
    <footer className="site-footer"><p>© {new Date().getFullYear()} Jacob Fishman</p><a href="#top">Back to top ↑</a></footer>
  </div>;
}
export default App;
